/**
 * Display helpers for a website typed into an organization record, which
 * arrives as "https://Example.com/", "www.example.com" or "EXAMPLE.COM".
 * Stored values are normalised on save (backend `normalizeWebsite`); these
 * cover rows saved before that.
 */

export interface WebsiteDisplay {
  /** Scheme-less, lowercase-host label with no trailing slash. */
  label: string;
  /** Always an https:// (or the typed http://) link target. */
  href: string;
}

export function formatWebsite(raw: unknown): WebsiteDisplay | null {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed || /\s/.test(trimmed)) return null;

  const schemeMatch = /^(https?):\/\//i.exec(trimmed);
  const scheme = schemeMatch ? schemeMatch[1].toLowerCase() : 'https';
  const rest = schemeMatch ? trimmed.slice(schemeMatch[0].length) : trimmed;
  const hostEnd = rest.search(/[/?#]/);
  const host = (hostEnd === -1 ? rest : rest.slice(0, hostEnd)).toLowerCase();
  if (!host || !host.includes('.')) return null;
  const tail = hostEnd === -1 ? '' : rest.slice(hostEnd);
  const href = `${scheme}://${host}${tail}`;
  const label = `${host}${tail}`.replace(/\/+$/, '');
  return { label, href };
}
